import { Box } from '@mui/material';
import { Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Maybe } from '@/types';
import { BlogDetailsPage } from '@/types/generated';

import BlogListItem, { ICardDesignType } from './BlogListItem';
import { wrapper, getSwiperStyles } from './BlogCarousel.styles';

interface ICardCarousel {
	blogsList: Array<BlogDetailsPage>;
	isDarkBackground?: boolean;
	enableMobileCarouselNavigation?: boolean;
	enableResourceCardMode?: boolean;
	isSmallScreen?: boolean;
	isExtraSmallScreen?: boolean;
	useCardMediaRoundedCorners?: boolean;
	useSmallScreenCarouselDesign?: boolean;
	buttonLabel: string;
	cardDesignType?: ICardDesignType;
	displayType?: Maybe<string>;
}

export default function CardCarousel({
	blogsList,
	buttonLabel,
	isSmallScreen = true,
	enableMobileCarouselNavigation = false,
	cardDesignType,
	displayType,
}: Readonly<ICardCarousel>) {
	return (
		<Box data-testid="section_card_carousel" sx={wrapper}>
			<Swiper
				slidesPerView={1.2}
				spaceBetween={16}
				pagination={{ clickable: true }}
				modules={isSmallScreen && enableMobileCarouselNavigation ? [Navigation, Pagination] : [Pagination]}
				style={getSwiperStyles}
				slidesOffsetBefore={20}
				slidesOffsetAfter={20}
			>
				{blogsList?.map((item, index) =>
					item ? (
						<SwiperSlide key={index}>
							<BlogListItem
								blogDetails={item}
								buttonLabel={buttonLabel}
								key={item._id}
								cardDesignType={cardDesignType}
								displayType={displayType ?? undefined}
							/>
						</SwiperSlide>
					) : null
				)}
			</Swiper>
		</Box>
	);
}
